import React from 'react';
import TextExtended from '../../text-extended/text-extended';
import styles from './comment-pending-footer.scss';
import { useTranslate } from '../../../context/api-context/translations/use-translate';
const CommentPendingFooter = () => {
    const t = useTranslate();
    return (React.createElement("div", { className: styles.container },
        React.createElement(TextExtended, { priority: "secondary", typography: "contentSmall" }, t('comment-footer.publishing'))));
};
export default CommentPendingFooter;
//# sourceMappingURL=comment-pending-footer.js.map